import Reactotron from 'reactotron-react-js'

export default Reactotron
